<template>
    <div class="main_container">
        <div class="layout_split">
            <RightWing :index="2" :score="score" />

            <div class="main_area">
                <div style="opacity:0; font-size:10px;">space</div>

                <div class="section_title_container">
                    <div class="section_title">{{sectionTitle}}</div>
                    <div class="article_title">"{{articleTitle}}"</div>
                </div>
                <div class="article_title_mobile">{{articleTitle}}</div>
                
                <div class="flex_container">
                    <!-- :class="{flex_item_entered: clue.entered, flex_item_chosen: clue.chosen}" -->
                    <div v-for="(clue, index) in clueList" :key="clue.title"
                            class="flex_item"
                            :class="{flex_item_entered: clue.entered, flex_item_chosen: clue.chosen}"
                            @click="selectClue(index)">

                        <div class="flex_item_media">
                            <div class="media_image_container">
                                <img :src="icon[clue.media]" height="30">
                            </div>
                            <div class="media_text">{{clue.media}}</div>
                            <div v-if="clue.checked" class="count_badge_container">
                                <span class="count_badge">{{clue.checked}}/{{clue.highlights}}</span>
                            </div>
                        </div>

                        <div>
                            <div class="flex_item_title">{{clue.title}}</div>
                            <span v-if="clue.checked" class="count_badge_mobile">{{clue.checked}}/{{clue.highlights}}</span>
                        </div>
                    </div>
                </div>
                
                <!-- <div style="font-size:20px; text-align:center; color:#707070;">발견한 근거: {{countChosen}}/3</div> -->

                <div class="btn_container">
                    <div class="btn_other_articles" @click="before">다른 주제 선택하기</div>
                    <div v-if="toNext" class="btn_to_next" @click="next">판별하기</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import RightWing from '../components/RightWingView.vue'
export default {
    name: 'ClueListView3',

    components: {
        'RightWing': RightWing
    },

    data() {
        return {
            sectionTitle: null,
            articleTitle: null,
            clueList: null,
            currentPlay: null,
            toNext: false,
            countChosen: 0,
            score: null,
            icon: {
                '카카오톡': require('../assets/img/icon_kkotalk.png'),
                '신문': require('../assets/img/icon_newspaper.png'),
                '논문': require('../assets/img/icon_paper.png'),
                '유튜브': require('../assets/img/icon_youtube.png'),
                '인스타그램': require('../assets/img/icon_insta.png'),
                '카페': require('../assets/img/icon_cafe.png'),
                '페이스북': require('../assets/img/icon_fb.png'),
                '방송뉴스': require('../assets/img/icon_interview.png'),
                '지식인': require('../assets/img/icon_knowledge.png'),
                '블로그': require('../assets/img/icon_blog.png'),
            }
        }
    },

    mounted() {
        this.currentPlay = this.$getCurrentGame()
        this.score = this.currentPlay.score

        // 화면에 데이터 표시하기 위해서 타이틀과 근거 목록을 세팅
        const selectedArticleData = this.$gameData.sections[this.currentPlay.selectedSection].articles[this.currentPlay.selectedArticle]
        this.sectionTitle = this.$gameData.sections[this.currentPlay.selectedSection].title
        this.articleTitle = selectedArticleData.title
        this.clueList = selectedArticleData.clues

        // 처음 들어오는 article인 경우 currentPlay.articles에 push해둔다
        if(this.currentPlay.articles == null) {
            this.currentPlay.articles = []
        }
        let currentArticleIndex = this.findCurrentArticleIndex()
        if(currentArticleIndex == -1) {
            // clues는 열어본 clue리스트, cluesChosen는 채택한 clue리스트
            this.currentPlay.articles.push(
                {'title': this.articleTitle, 'clues': [], 'cluesChosen': [], 'desc': selectedArticleData.desc})
            this.$setCurrentGame(this.currentPlay)
        }
        // 이미 이 article에 들어 온 적 있음. 따라서 근거를 선택했다면 선택된 근거를 보여줘야 함
        else {
            let count = 0
            let cluesChosen = this.currentPlay.articles[currentArticleIndex].cluesChosen
            for(let i = 0; i < this.clueList.length; i++) {
                for(let j = 0; j < cluesChosen.length; j++) {
                    if(this.clueList[i].title == cluesChosen[j].title) {
                        this.clueList[i].chosen = true
                        count++
                        // 채택한 근거가 있으면 판별하기 버튼 활성화
                        this.toNext = true
                    }
                }
            }
            this.countChosen = count

            for(let i = 0; i < this.clueList.length; i++) {
                for(let j = 0; j < this.currentPlay.articles[currentArticleIndex].clues.length; j++) {
                    if(this.clueList[i].title == this.currentPlay.articles[currentArticleIndex].clues[j].title) {
                        // console.log(this.clueList[i])
                        // console.log(this.currentPlay.articles[currentArticleIndex].clues[j])
                        if(this.currentPlay.articles[currentArticleIndex].clues[j].items.length > 0) {
                            this.clueList[i].entered = true
                            this.clueList[i].checked = this.currentPlay.articles[currentArticleIndex].clues[j].items.length
                            this.clueList[i].highlights = this.currentPlay.articles[currentArticleIndex].clues[j].highlightsCount
                        }
                    }
                }
            }
        }        
    },

    methods: {
        selectClue: function(index) {
            // 이미 선택한 내용 선택 막기
            if(this.clueList[index].chosen) {
                return
            }
            this.currentPlay.selectedClue = index
            this.$setCurrentGame(this.currentPlay)
            this.$router.push('/clueDetail3')
        },

        findCurrentArticleIndex: function() {
            let currentArticleIndex = -1
            for(let i = 0; i < this.currentPlay.articles.length; i++) {
                let article = this.currentPlay.articles[i]
                if(article.title == this.articleTitle) {
                    currentArticleIndex = i
                    break
                }
            }
            return currentArticleIndex
        },

        before: function() {
            this.$router.push('/articleList')
        },

        next: function() {
            this.$router.push('/selectTrueOrNot')
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


/* pc */
@media screen and (min-width: 415px) {
    .flex_container {
        margin-left: 90px;
        margin-right: 90px;
        margin-top: 10px;
        margin-bottom: 10px;
        
        display:flex;
        flex-wrap:wrap;
        justify-content:space-around;
    }
    .flex_item {
        font-size: 26px;
        margin: 8px 0px;
        padding: 20px;

        border: solid black 1px;
        box-shadow:3px 3px 3px grey;
        background-color: white;

        width:250px;
        height:170px;
        cursor:pointer;
    }
    .flex_item_media {
        display: flex;
        font-size: 20px;
        font-weight: 400;
        margin-bottom: 5px;
        /* align-items:center; */
    }
    .flex_item_title {
        font-weight: 700;
    }

    .btn_other_articles {
        text-align: center;
        width: 280px;

        padding: 10px;
        margin: 0px 10px;

        border: 2px solid black;

        font-weight: 700;
        font-size: 26px;
        color: black;

        cursor:pointer;
        background-color: white;
        box-shadow:3px 3px 3px grey;
    }
    .btn_to_next {
        text-align: center;
        width: 280px;

        padding: 10px;
        margin: 0px 10px;

        border: 2px solid black;

        font-weight: 700;
        font-size: 26px;
        color: white;

        cursor:pointer;
        background-color: black;
        box-shadow:3px 3px 3px grey;
    }
    .btn_container {
        margin-top: 5px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .count_badge {
        font-size:15px;
        background-color:black;
        color:white;
        border-radius:20px;
        padding:5px 15px;
        margin-left:5px;
    }

    .layout_split {
        display:flex;
    }
    .main_area {
        width: 100%;
        background-color:#e5e5e5
    }
    .section_title_container {
        display:flex;
        margin-left:20px;
    }
    .article_title_mobile {
        display: none;
    }
    .media_image_container {
        margin-right: 10px;
    }
    .count_badge_container {
        text-align: right;
        flex-grow: 1;
    }
    .media_text {
        padding-top: 2px;
    }
    .count_badge_mobile {
        display: none;
    }
}


/* mobile */
@media screen and (max-width: 414px) {
    .layout_split {
        display:flex;
        flex-direction:column;
    }
    .main_area {
        width:100%;
        background-color:#e5e5e5
    }
    .section_title_container {
        display: none;
    }
    .article_title_mobile {
        text-align: center;
        color: black;
        font-size: 22px;
        font-weight: 700;
        /* border-bottom: solid black 1px; */
        text-decoration: underline;
    }

    .flex_container {
        margin-left: 0px;
        margin-right: 0px;
        margin-top: 10px;
        margin-bottom: 10px;
        
        display:flex;
        flex-direction: column;
        justify-content:space-between;
    }
    .flex_item {
        font-size: 18px;
        margin: 8px 10px;
        padding: 10px;
        border: solid black 1px;
        box-shadow:3px 3px 3px grey;
        background-color: white;
        /* width:250px; */
        height:85px;
        display: flex;
    }
    .flex_item_media {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-items: center;
        justify-content: center;
        width: 80px;
        /* align-items:center; */
    }
    .media_image_container {
        margin-right: 0px;
    }
    .count_badge_container {
        /* text-align: right;
        flex-grow: 1; */
        display: none;
    }
    .media_text {
        font-size: 14px;
        font-weight: 700;
    }
    .count_badge {
        font-size:15px;
        background-color:black;
        color:white;
        border-radius:20px;
        padding:5px 15px;
        margin-left:5px;
    }
    .btn_container {
        margin-top: 5px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .btn_to_next {
        text-align: center;
        padding: 10px;
        margin-top: 10px;
        margin-bottom: 30px;
        margin-left: 10px;
        margin-right: 10px;
        border: 2px solid black;
        flex-grow: 1;
        font-weight: 700;
        font-size: 26px;
        color: white;
        background-color: black;
        box-shadow: 2px 2px 2px grey;
    }
    .flex_item_title {
        width: 230px;
        height: 28px;
        overflow: hidden;
        font-weight: 700;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .count_badge_mobile {
        font-size:12px;
        background-color:black;
        color:white;
        border-radius:15px;
        padding: 5px 12px;
        margin-left:5px;
    }
    .btn_other_articles {
        display: none;
    }
}


.flex_item_entered {
    border: solid 2px black;
    /* background-color: #DF5D5B; */
}
.flex_item_chosen {
    background-color: #64ACF8;
}

</style>
